import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartVectorUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 10,
	viewBox: "0 0 16 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.87293 9.12424C1.16543 9.41674 1.63793 9.41674 1.93043 9.12424L5.37293 5.68174C5.66543 5.38924 6.13793 5.38924 6.43043 5.68174L7.30793 6.55924C8.18543 7.43674 9.61043 7.43674 10.4879 6.55924L13.6229 3.43174L14.7029 4.51174C14.9354 4.74424 15.3404 4.57924 15.3404 4.24924V1.03174C15.3479 0.821738 15.1829 0.656738 14.9729 0.656738H11.7554C11.4179 0.656738 11.2529 1.06174 11.4929 1.29424L12.5729 2.37424L9.44543 5.50174C9.15293 5.79424 8.68043 5.79424 8.38793 5.50174L7.51043 4.62424C6.63293 3.74674 5.20793 3.74674 4.33043 4.62424L0.87293 8.06674C0.58793 8.35924 0.58793 8.83924 0.87293 9.12424Z",
		fill: "#3C59F6"
	})
});
export default SvgChartVectorUp;
